export default __webpack_public_path__ + "static/media/thumbnail.8d3fc822.webp";